import { AbstractObject } from "../abstract-object";
import { LocalDateTime } from "../local-date-time/local-date-time";
import { QuestionnaireSectionType } from "../questionnaire-template/questionnaire-template-section.model";
import { QuestionnaireResultAnswer } from "./questionnaire-result-answer.model";

export class QuestionnaireResultSection extends AbstractObject {
    /**
     * A kitöltött kérdőív-szekció sorszáma. Meg kell, hogy egyezzen a sablon
     * megfelelő szekciójának sorszámával (order).
     * - kötelező
     * - típusa integer
     * - 0-nál nagyobb
     * - kérdőív-kitöltésenként egyedinek kell lennie
     * - a sablonban kell ilyen order értékű szekciónak lennie
     */
    order: number = 0;

    /**
     * @see QuestionnaireSectionType
     * - kötelező (lehet 0)
     * - típusa integer
     * - a kapcsolódó kérdőív típusával meg kell egyezzen
     */
    type?: QuestionnaireSectionType = null;

    /**
     * A szekcióban lévő kérdésekre adott válaszok.
     * - kötelező
     * - 'Finished' státusz esetén nem lehet üres
     * - 'Finished' státusz esetén elemszámának meg kell egyezzen a kapcsolódó
     *   sablon-szekcióban lévő kérdések számával
     */
    answers?: QuestionnaireResultAnswer[] = [];

    /**
     * A kérdőív-szakasz kitöltés kezdetének időpontja.
     * - 'Finished' státusz esetén kötelező
     */
    startedAt?: LocalDateTime = null;
    /**
     * A kérdőív-szakasz kitöltés befejezésének időpontja.
     * - 'Finished' státusz esetén kötelező
     * - nem lehet kisebb, mint a startedAt
     */
    finishedAt?: LocalDateTime = null;

    /**
     * Az osztály konstruktora.
     * @param data 
     */
    constructor(data?: any) {
        super();
        super.init(data, this);
        if (this.startedAt) {
            this.startedAt = new LocalDateTime(this.startedAt);
        }
        if (this.finishedAt) {
            this.finishedAt = new LocalDateTime(this.finishedAt);
        }
        if (Array.isArray(this.answers)) {
            this.answers = this.answers.map(item => new QuestionnaireResultAnswer(item));
        }
    }
}